// Static legal areas data - no database connection required
const staticLegalAreas = [
  {
    id: '1',
    name: 'Vertragsrecht',
    description: 'Professionelle Beratung bei Vertragsangelegenheiten. Prüfung und Gestaltung von Verträgen. Durchsetzung vertraglicher Ansprüche. Beratung bei Vertragsverletzungen. Unterstützung bei Vertragsverhandlungen.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '2',
    name: 'Schuldenrecht',
    description: 'Umfassende Beratung bei Schulden und Forderungen. Unterstützung bei Mahnverfahren. Beratung zur Insolvenz. Verhandlung mit Gläubigern. Schuldenregulierung und Sanierung.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '3',
    name: 'Urheberrecht',
    description: 'Schutz geistigen Eigentums und kreativer Werke. Beratung bei Urheberrechtsverletzungen. Lizenzverträge und Nutzungsrechte. Abmahnungen und Unterlassungserklärungen. Durchsetzung von Urheberrechten.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '4',
    name: 'Strafrecht',
    description: 'Verteidigung in Strafverfahren aller Art. Beratung bei Ermittlungsverfahren. Vertretung vor Gericht. Akteneinsicht und Beweissicherung. Rechtsbeistand bei Vernehmungen.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '5',
    name: 'Familienrecht',
    description: 'Beratung in allen familienrechtlichen Angelegenheiten. Scheidung und Trennung. Sorgerecht und Umgangsrecht. Unterhaltsfragen. Vermögensauseinandersetzung.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '6',
    name: 'Arbeitsrecht',
    description: 'Rechtliche Unterstützung im Arbeitsverhältnis. Kündigungsschutz und Abfindungen. Arbeitsverträge und Aufhebungsverträge. Abmahnungen und Zeugnisse. Betriebsrat und Tarifrecht.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '7',
    name: 'Mietrecht',
    description: 'Beratung für Mieter und Vermieter. Mieterhöhungen und Betriebskosten. Mängel und Gewährleistung. Kündigungen und Räumungsklagen. Mietvertragsgestaltung.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  },
  {
    id: '8',
    name: 'Verkehrsrecht',
    description: 'Rechtsbeistand nach Verkehrsunfällen. Schadensregulierung und Schmerzensgeld. Bußgeldverfahren und Führerscheinentzug. Versicherungsrecht. Gutachten und Beweissicherung.',
    is_active: true,
    created_at: '2024-01-01T00:00:00Z'
  }
];

export const legalAreasService = {
  // Get all active legal areas (static data)
  async getAllAreas() {
    try {
      // Simulate async behavior
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const activeAreas = staticLegalAreas?.filter(area => area?.is_active);
      return { data: activeAreas, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to load legal areas' };
    }
  },

  // Get legal area by ID
  async getAreaById(id) {
    try {
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const area = staticLegalAreas?.find(area => area?.id === id && area?.is_active);
      
      if (!area) {
        return { data: null, error: 'Legal area not found' };
      }
      
      return { data: area, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to load legal area' };
    }
  },

  // Get areas by category/search
  async searchAreas(searchTerm) {
    try {
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const lowerSearchTerm = searchTerm?.toLowerCase() || '';
      const filteredAreas = staticLegalAreas?.filter(area => {
        if (!area?.is_active) return false;
        
        const nameMatch = area?.name?.toLowerCase()?.includes(lowerSearchTerm);
        const descMatch = area?.description?.toLowerCase()?.includes(lowerSearchTerm);
        
        return nameMatch || descMatch;
      });
      
      return { data: filteredAreas, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to search legal areas' };
    }
  },

  // Admin functions (for future use - currently return static data)
  async createArea(areaData) {
    try {
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const newArea = {
        id: String(staticLegalAreas?.length + 1),
        name: areaData?.name || 'New Legal Area',
        description: areaData?.description || 'Description',
        is_active: areaData?.is_active ?? true,
        created_at: new Date()?.toISOString()
      };
      
      // Note: This won't persist as we're using static data
      return { data: newArea, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to create legal area' };
    }
  },

  async updateArea(id, areaData) {
    try {
      await new Promise(resolve => setTimeout(resolve, 100));
      
      const area = staticLegalAreas?.find(area => area?.id === id);
      
      if (!area) {
        return { data: null, error: 'Legal area not found' };
      }
      
      const updatedArea = {
        ...area,
        name: areaData?.name ?? area?.name,
        description: areaData?.description ?? area?.description,
        is_active: areaData?.is_active ?? area?.is_active
      };
      
      // Note: This won't persist as we're using static data
      return { data: updatedArea, error: null };
    } catch (error) {
      return { data: null, error: 'Failed to update legal area' };
    }
  }
};